import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import App from 'core/App';

ReactDOM.render(<React.StrictMode> <App /> </React.StrictMode>, document.getElementById('root'));
serviceWorker.unregister(); // use unregister to disable service worker
